import { Button, makeStyles } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSessionMarker, updateMarker } from '../../../store/actions/creator/analysis';
import LiveAnnotation from '../../pages/creator/experienceManager/analysis/live/annotation';

const useStyles = makeStyles(() => ({
  text: {
    textAlign: 'center',
    fontSize: 24,
    color: '#697683',
    fontFamily: 'roboto-bold',
  },
  note: {
    margin: '12px 20px 3px',
    padding: '9px 12px',
    fontSize: 16,
    background: '#fff',
    boxShadow: '0 0 5px rgb(0 0 0 / 20%)',
    borderRadius: 8,
    fontFamily: 'roboto-regular',
  },
  postBtn: {
    height: 37,
    margin: 12,
    borderRadius: 6,
    background: '#0179EE',
    color: 'white',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0d77d4',
    },
  },
}));

function AnalyzeLiveMemoSection() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);

  const { markers } = useSelector((state: any) => state.analysis);
  const [comments, setComments] = useState<any[]>([]);
  const [notePostBox, setNotePostBox] = useState(false);
  const annotationRef: any = useRef();
  const { currentSession } = useSelector((state: any) => state.analysis);
  const { analyseStart, session_code } = currentSession;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

  useEffect(() => {
    setComments(markers.filter((item: any) => item.marker_type !== 1 && item.start_marker_at !== "0"));
  }, [markers]);

  const onPostAnnotation = (start_at: any, annotation: any) => {

    const request: any = {
      session_code,
      marker_title: annotation,
      marker_start_at: Math.floor(Number(start_at)).toString(),
      marker_end_at: Math.floor(Number(start_at + 5)).toString(),
      marker_type: randomIntFromInterval(3, 7),
      user_id: parseInt(loginUserData.user_id),
      marker_id: null,
    };

    dispatch(updateMarker(apolloClient.client, request, () => {
      setTimeout(()=> dispatch(fetchSessionMarker(apolloClient.client, { session_code })), 1000)
    }))

  }

  return (
    <div style={{ marginTop: 40 }}>
      <div className={classes.text}>Notes</div>

      {
        !notePostBox &&
        <Button
          variant="contained"
          color="secondary"
          className={classes.postBtn}
          onClick={() => setNotePostBox(true)}
        >
          Add Note
        </Button>
      }

      {
        notePostBox &&
        <div style={{ margin: 12 }}>
          <LiveAnnotation
            ref={annotationRef}
            onAddNote={(start_at: any, annotation: any) => onPostAnnotation(start_at, annotation)}
            onCloseBox={() => setNotePostBox(false)}
            sessionType={'MODERATED'}
            analyseStart={analyseStart}
          />
        </div>
      }

      {comments.map((item, index) => <div key={index} className={classes.note}>
        {item.marker_title}
      </div>)}

    </div>
  );
}

export default AnalyzeLiveMemoSection;

function randomIntFromInterval(min: number, max: number) { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min)
}